import { DATE_INPUT_DISPLAY_FORMAT } from 'module/types/common';
import {
  BackgroundColor,
  InputBorder,
  InputFocus,
} from 'module/ui/components/atoms/input/input';
import { DatePicker as AntDatePicker } from 'antd';
import { DatePickerProps } from 'antd/lib/date-picker';
import { forwardRef } from 'react';
import styled from 'styled-components';

const Picker = forwardRef<any, DatePickerProps>((props, ref) => {
  return (
    <AntDatePicker ref={ref} format={DATE_INPUT_DISPLAY_FORMAT} {...props} />
  );
});

Picker.displayName = 'DatePicker';

export const DatePicker = styled(Picker)<DatePickerProps>`
  ${InputBorder};
  ${BackgroundColor};
  padding: 0 var(--spacing-05);
  &.ant-picker-disabled {
    opacity: 0.5;
  }
  &.ant-picker-focused {
    ${InputFocus};
  }

  .ant-picker-input {
    padding: var(--spacing-02) 0px;
  }
`;
